// src/fontAwesome.js
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
  faCar,
  faCog,
  faUsers,
  faGasPump,
  faCheck,
} from "@fortawesome/free-solid-svg-icons";

// Add icons to the library
library.add(faCar, faCog, faUsers, faGasPump, faCheck);

// Register the component globally
export default {
  install(Vue) {
    Vue.component("font-awesome-icon", FontAwesomeIcon);
  },
};
